module.exports = __webpack_public_path__ + "img/upgrade.8a80f418.svg";